import React, { Component } from 'react';
import { Popover, PopoverBody } from 'reactstrap';
import checked from '../../../../assets/images/topicChecked.svg';
import uncheck from '../../../../assets/images/topicUncheck.svg';
import TopicArrow from '../../../../assets/images/questionTopicArrow.svg';
import TopicArrowActive from '../../../../assets/images/questionTopicArrowActive.svg';
import topicHintIcon from '../../../../assets/images/topic-hint-icon.svg';

import './topicItem.css';

export default class TopicItem extends Component {

  constructor(props) {
    super(props);
    this.state = {
      popoverOpen: false
    };
  }

  toggle = () => {
    this.setState({
      popoverOpen: !this.state.popoverOpen
    });
  }



  render() {
    let popHover = null;
    if (this.props.isActive) {
      popHover = [
        <span id={'Popover' + this.props.index} onClick={(e) => {
          this.toggle();
          e.cancelBubble = true;
          e.stopPropagation();
        }} key={this.props.index}><img src={topicHintIcon} alt="topicHintIcon" /></span>,
        <Popover placement="right" target={'Popover' + this.props.index} isOpen={this.state.popoverOpen} toggle={this.toggle} key={this.props.topicId}>
          <PopoverBody>{this.props.description}</PopoverBody>
        </Popover>
      ]
    }
    return (
      <a onClick={() => {this.props.onClick(this.props.topicId, this.props.index)}} className={this.props.isActive ? 'question-topic-item-container active' : 'question-topic-item-container'}>
        <div className="check-left">
          <img src={this.props.checked ? checked : uncheck} alt="" />
        </div>
        <div className="content-middle">
          <p className={this.props.isActive ? 'item-description-active' : 'item-description'}>
            {this.props.charIndex}. {this.props.itemDetails}
          </p>
          {popHover}
        </div>
        <div className="content-right" >
          <img src={this.props.isActive ? TopicArrowActive : TopicArrow} alt="" />
        </div>
      </a >
    );
  }
}




// WEBPACK FOOTER //
// ./src/screens/Question/components/TopicItem/TopicItem.js